import { useStyles } from "@b2bportal/core-themes";
import { CORE_FLIGHTS_REBOOK_NAME } from "~core-flights-rebook/components/rebook-component";
import type { CoreFlightsRebookComponent } from "~core-flights-rebook/components/rebook-component";

export const useFlightsRebookStyles = (
  componentName: keyof typeof CoreFlightsRebookComponent,
  defaultStyles?: object
) => {
  return useStyles(CORE_FLIGHTS_REBOOK_NAME, componentName, defaultStyles);
};
